/* Custom element also initializes when Shopify reloads a section in the editor. */
if (!customElements.get('revv-can-motion')) {
  customElements.define('revv-can-motion', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.pointer = matchMedia('(hover: hover) and (pointer: fine)');
      this.userPaused = false;
      this.visible = true;
      this.addEventListener('pointermove', event => {
        if (!this.pointer.matches || this.reduced.matches || this.userPaused) return;
        const box = this.getBoundingClientRect();
        this.style.setProperty('--pointer-x', `${((event.clientX - box.left) / box.width - .5) * 6}px`);
        this.style.setProperty('--pointer-y', `${-((event.clientY - box.top) / box.height - .5) * 4}px`);
      }, options);
      this.addEventListener('pointerleave', () => this.resetPointer(), options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.reduced.addEventListener('change', () => { this.resetPointer(); this.sync(); }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        });
        this.observer.observe(this);
      }
      this.sync();
    }
    resetPointer() {
      this.style.removeProperty('--pointer-x');
      this.style.removeProperty('--pointer-y');
    }
    sync() {
      this.toggleAttribute('data-paused', this.userPaused || this.reduced.matches || !this.visible || document.hidden);
      if (this.userPaused) this.resetPointer();
    }
    disconnectedCallback() {
      this.controller.abort();
      this.observer?.disconnect();
    }
  });
}
